import React from 'react';
import {formatCurrencyValue} from "../../../util/PaymentUtils";
import {ListGroupItem} from "react-bootstrap";

interface CostBreakdownListGroupItemProps {
  title?: string;
  /**
   * Typed as ReactNode because InvoiceListGroupItem currently passes the string[] result of
   * `description.split(...)`, which React renders by concatenating the array entries.
   */
  description?: React.ReactNode;
  /** Amount in cents. May be undefined while the parent's booking transaction is loading. */
  amount?: number | null;
}

const CostBreakdownListGroupItem = (props: CostBreakdownListGroupItemProps) => {
  const {title, description, amount} = props;
  
  const titleStyle = {
    fontSize: '1.15rem',  
  };
  
  const descriptionStyle = {
    fontSize: '0.875rem', 
    color: '#6c757d',
  };
  
  const amountStyle = {
    fontSize: '1rem', 
  };

  return (
    <ListGroupItem className={'d-flex justify-content-between align-items-center mt-2'}>
      <div>
        <h6 style={titleStyle}>{title}</h6>
        {description && <small style={descriptionStyle}>{description}</small>}
      </div>
      <div style={amountStyle}>
        {/* formatCurrencyValue returns null/undefined input unchanged (renders nothing), so skip the call
            for those values rather than coalescing to 0, which would render "$0" instead. */}
        {amount !== null && amount !== undefined && formatCurrencyValue(amount, true)}
      </div>
    </ListGroupItem>
  );
}

export default CostBreakdownListGroupItem;
